import React, { useEffect, useRef, useState } from "react"
import {
    Users,
    Wallet,
    Activity,
    Briefcase,
    Download,
    Edit,
    MoreVertical,
    ChevronDown,
} from "lucide-react"
import {
    LineChart,
    Line,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    AreaChart,
    Area,
    PieChart,
    Pie,
    Cell,
} from "recharts"
import nodata from "../../Utils/assets/img/leads_no_data_found_removebg.png";
import {
    IconActivity,
    IconBriefcase,
    IconCurrencyRupee,
    IconLoader2,
    IconPoint,
    IconUser,
    IconUsers,
    IconWallet,
    IconX,
} from "@tabler/icons-react"
import "./crmDashboard/CrmDashboard.css"
// import "../CrmDashboard.css"
import useLocalStorageState from "use-local-storage-state"
import { GetRequest } from "../../Utils/hooks/ApiHandler"
import { useNavigate } from "react-router-dom"
import { Dropdown, Image, Nav } from "react-bootstrap"
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { toast } from "sonner"
import { downloadCSV, putCommaInLeadsValue } from "../../Utils/helpers/commonhelper"
import { LeadsBySource } from "./crmDashboard/LeadsBySource";
import { DealStatuaStats } from "./crmDashboard/DealStatuaStats";
import { TopDeals } from "./crmDashboard/TopDeals";
import { DealStatistics } from "./crmDashboard/DealStatistics";
import { RecentActivity } from "./crmDashboard/RecentActivity";
import { RevenueAnalytics } from "./crmDashboard/RevenueAnalytics";

export const MyDashboard = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate()

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const [isPlanEnding, setIsPlanEnding] = useState(false)
    const [isVisible, setIsVisible] = useState(false)
    const [isClosing, setIsClosing] = useState(false)
    const hasShownRef = useRef(false);

    const customersData = [
        { value: 15 },
        { value: 5 },
        { value: 70 },
        { value: 55 },
    ]
    const [cardDetailsData, setCardDetailsData] = useState(null)

    //state for profit data
    const [profitData, setProfitData] = useState([])
    // // revenue analytics statee1
    // const [revenueDuration, setRevenueDuration] = useState("year")
    // const [analyticsData, setAnalyticsData] = useState([])

    // profit earned api calling
    useEffect(() => {
        ; (async () => {
            const res = await GetRequest(
                `dashboard/profitEarned/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                { headers },
                extras
            )
            if (res.status === false) {
                return
            }
            if (res.data) {
                const data = res.data?.labels?.map((label, index) => ({
                    day: label.charAt(0),
                    collection: res.data.data["collection"][index],
                    expense: res.data.data["expense"][index],
                }))
                setProfitData(data)
            }
        })()
    }, [])

    // card details api fetch
    useEffect(() => {
        ; (async () => {
            try {
                const res = await GetRequest(
                    `dashboard/CardDetails/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                    { headers },
                    extras
                )
                if (res.status === false) {
                    return
                }
                setCardDetailsData({
                    contacts: {
                        title: "Total Customers",
                        icon: <IconUsers size={20} style={{ stroke: "white" }}></IconUsers>,
                        color: "#845adf",
                        value: Number(res.data["total_contacts"]).toFixed(0),
                        percentage: Number(
                            res.data["contact_thisMonth_percentage"]
                        ).toFixed(2),
                    },
                    conversion: {
                        title: "Total Conversion",
                        color: "#26bf94",
                        icon: (
                            <IconActivity
                                size={20}
                                style={{ stroke: "white" }}
                            ></IconActivity>
                        ),
                        value: Number(res.data["conversion"]).toFixed(2) + "%",
                        percentage: Number(res.data["this_monthConversion"]).toFixed(2),
                    },
                    revenue: {
                        title: "Total Revenue",
                        color: "#23b7e5",
                        icon: (
                            <IconWallet size={20} style={{ stroke: "white" }}></IconWallet>
                        ),
                        value: putCommaInLeadsValue(Number(res.data["total_revenue"]).toFixed(2)),
                        percentage: Number(res.data["sales_thisMonth_percentage"]).toFixed(
                            2
                        ),
                    },
                    deals: {
                        title: "Total Deals",
                        color: "#f5b849",
                        icon: (
                            <IconBriefcase
                                size={20}
                                style={{ stroke: "white" }}
                            ></IconBriefcase>
                        ),
                        value: Number(res.data["total_deals"]).toFixed(0),
                        percentage: Number(res.data["this_monthDeals"]).toFixed(2),
                    },
                })
            } catch (error) {
                console.error("error fetching status data")
            }
        })()
    }, [])

    // status card component
    const CrmStatCard = ({
        icon: Icon,
        bgColor,
        title,
        value,
        chartData,
        changePercent,
        changeType,
        linkColor,
        module,
    }) => (
        <div
            className="crm-card crm-card-overflow-hidden"
            style={{ marginBottom: "12px" }}
        >
            <div className="p-3">
                <div className="d-flex align-items-start justify-content-between gap-2">
                    {/* Left Section - Icon and Stats */}
                    <div className="d-flex align-items-start gap-2 flex-grow-1">
                        {/* Icon */}
                        <div style={{ marginTop: "0.6rem" }}>
                            <span
                                className={`p-2`}
                                style={{ borderRadius: "50%", backgroundColor: `${bgColor}` }}
                            >
                                {Icon}
                            </span>
                        </div>

                        {/* Stats and Text Content */}
                        <div className="d-flex flex-column flex-grow-1">
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div>
                                    <p
                                        className="text-muted"
                                        style={{ fontSize: "14px", marginBottom: "0.4rem" }}
                                    >
                                        {title}
                                    </p>
                                    <h4
                                        className=""
                                        style={{ fontSize: "14px", fontWeight: 900 }}
                                    >
                                        {value}
                                    </h4>
                                </div>
                            </div>

                            {/* View All Link */}
                            {(module == "deals" || module === "contacts") && (
                                <div className="mt-1">
                                    <a
                                        className={`crm-text-${linkColor === "#845adf"
                                            ? "primary"
                                            : linkColor === "#23b7e5"
                                                ? "info"
                                                : linkColor === "#26bf94"
                                                    ? "success"
                                                    : "warning"
                                            }`}
                                        style={{ fontWeight: 500 }}
                                        href="#"
                                    >
                                        View All
                                        <i className="ti ti-arrow-narrow-right ms-2 fw-semibold d-inline-block"></i>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Section - Chart and Percentage */}
                    <div className="d-flex flex-column align-items-end">
                        {/* Chart */}
                        <div style={{ minHeight: 40, width: 100 }}>
                            <ResponsiveContainer width="100%" height={40}>
                                <LineChart data={chartData}>
                                    <defs>
                                        <linearGradient
                                            id="lineGradient"
                                            x1="0%"
                                            y1="0%"
                                            x2="100%"
                                            y2="0%"
                                        >
                                            <stop offset="0%" stopColor="#1a1a1a" />
                                            <stop offset="50%" stopColor={linkColor} />
                                            <stop offset="100%" stopColor={linkColor} />
                                        </linearGradient>
                                    </defs>
                                    <Line
                                        type="monotone"
                                        dataKey="value"
                                        stroke="url(#lineGradient)"
                                        strokeWidth={1.5}
                                        dot={false}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                        {/* Percentage at the end */}
                        <div className="text-end mt-1">
                            <p
                                className={`mb-0 fw-semibold ${changeType === "positive"
                                    ? "crm-text-success"
                                    : "crm-text-danger"
                                    }`}
                            >
                                {changePercent}%
                            </p>
                            <span className="text-muted op-7 fs-11">this month</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <>
            <div className="row mt-3">
                <div className="col-md-9 col-xxl-9 col-xl-9 col-md-12">
                    <div className="row">
                        <div className="col-xl-4">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="crm-card crm-custom-card crm-highlight-card">
                                        <div className="crm-card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <div className="fw-semibold fs-18 text-fixed-white mb-2">
                                                        Your target is incomplete
                                                    </div>
                                                    <span className="d-block fs-12 text-fixed-white">
                                                        <span className="op-7">You have completed</span>
                                                        <span className="fw-semibold text-warning">
                                                            {" "}
                                                            0%{" "}
                                                        </span>
                                                        <span className="op-7">
                                                            of the given target, you can also check your
                                                            status
                                                        </span>
                                                        .
                                                    </span>
                                                    <span className="d-block fw-semibold mt-1">
                                                        Click Here
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        minHeight: 105.7,
                                                        width: 100,
                                                        position: "relative",
                                                    }}
                                                >
                                                    <svg width="100" height="105.7" viewBox="0 0 100 125">
                                                        <circle
                                                            cx="50"
                                                            cy="62.5"
                                                            r="31.8"
                                                            fill="none"
                                                            stroke="#3272cc"
                                                            strokeWidth="4.8"
                                                        />
                                                        <circle
                                                            cx="50"
                                                            cy="62.5"
                                                            r="31.8"
                                                            fill="none"
                                                            stroke="rgba(255,255,255,0.9)"
                                                            strokeWidth="5"
                                                            strokeDasharray="200"
                                                            strokeDashoffset="104"
                                                            transform="rotate(-90 50 62.5)"
                                                            strokeLinecap="round"
                                                        />
                                                        <text
                                                            x="50"
                                                            y="70"
                                                            textAnchor="middle"
                                                            fill="white"
                                                            fontSize="14"
                                                            fontWeight="600"
                                                        >
                                                            48%
                                                        </text>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* top deal */}
                            <TopDeals />
                            {/* profit earned */}
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="crm-card crm-custom-card">
                                        <div className="crm-card-header justify-content-between">
                                            <div className="d-flex gap-2 align-items-center">
                                                <div className="crm-card-title addEnquiryHead">
                                                </div>
                                                <span className=" d-inline-block" style={{ marginTop: "3px", fontWeight: 600 }}>Profit Earned</span>
                                            </div>
                                        </div>
                                        <div className="crm-card-body pb-0 ps-0 " style={{ paddingTop: '1.2rem' }}>
                                            {profitData?.length !== 0 ?
                                                <div>
                                                    <ResponsiveContainer width="100%" height={180}>
                                                        <BarChart
                                                            data={profitData}
                                                            margin={{
                                                                top: 10,
                                                                right: 10,
                                                                left: 10,
                                                                bottom: 25,
                                                            }}
                                                        >
                                                            <XAxis
                                                                dataKey="day"
                                                                interval={0}
                                                                tick={{ fontSize: 11 }}
                                                                angle={0}
                                                                textAnchor="middle"
                                                                height={50}
                                                            />
                                                            <YAxis
                                                                tick={{ fontSize: 11 }}
                                                                domain={[0, "dataMax + 1000"]}
                                                                tickCount={6}
                                                                interval="preserveStartEnd"
                                                                tickFormatter={(value) => `₹${value}`}
                                                            />
                                                            <Tooltip
                                                                formatter={(value) => [`₹${value}`, ""]}
                                                                labelFormatter={(label) => `Day: ${label}`}
                                                            />
                                                            <Bar
                                                                dataKey="collection"
                                                                fill="#845adf"
                                                                radius={[4, 4, 0, 0]}
                                                                barSize={12}
                                                                name="Collection"
                                                            />
                                                            <Bar
                                                                dataKey="expense"
                                                                fill="rgba(228,231,237,0.85)"
                                                                radius={[4, 4, 0, 0]}
                                                                barSize={12}
                                                                name="Expense"
                                                            />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </div>
                                                :
                                                <div
                                                    className="d-flex justify-content-center align-items-center"
                                                    style={{ position: "absolute", left: "10%", top: "3rem" }}
                                                >
                                                    <img
                                                        src={nodata}
                                                        alt="nodata_found_img"
                                                        style={{ width: "17rem", marginTop: "0" }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* top cards */}
                        <div className="col-xl-8">
                            <div className="row">
                                {cardDetailsData !== null &&
                                    Object.entries(cardDetailsData)?.map(([key, value]) => (
                                        <div className="col-xxl-6 col-lg-6 col-md-6">
                                            <CrmStatCard
                                                icon={value.icon}
                                                module={key}
                                                bgColor={value.color}
                                                title={value.title}
                                                value={value.value}
                                                chartData={customersData}
                                                changePercent={value.percentage}
                                                changeType="positive"
                                                linkColor={value.color}
                                            />
                                        </div>
                                    ))
                                }

                                <RevenueAnalytics />
                            </div>
                        </div>

                        <DealStatistics />
                    </div>
                </div>

                <div className="col-md-3 col-xxl-3 col-xl-3 col-md-12">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12">
                            <div className="row">
                                {/* leads by source */}
                                <LeadsBySource />


                                {/* deals status */}
                                <DealStatuaStats />

                                {/* revenue analytics */}
                                <RecentActivity />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
